'use client';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { warm, lighterGrey } from '@style/variables';

interface BoxProps {
  white?: boolean;
}

export const StyledBox = styled(Box)<BoxProps>`
  overflow-x: scroll;
  padding:  0 0 2rem 0;
  &::-webkit-scrollbar {
    height: 8px;
    padding-left: 2rem;
    padding-right: 2rem;
    -webkit-appearance: none;
  }
  
  &::-webkit-scrollbar-track {
    background: ${(props) => (props.white ? '#42474a' : warm[300])};
    border-left: 1em solid rgba(0, 0, 0, 0);
    border-right: 1em solid rgba(0, 0, 0, 0);
    border-top: 2px solid rgba(0,0,0,0);
    border-bottom: 2px solid rgba(0,0,0,0);
    background-clip: padding-box;
  },
  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => (props.white ? lighterGrey : warm[900])};
    box-shadow:${(props) => (props.white ? lighterGrey : '0 0 1px rgba(255, 255, 255, 0.5)')};
    border-left: 1em solid rgba(0, 0, 0, 0);
    border-right: 1em solid rgba(0, 0, 0, 0);
    height: 2rem;
    background-clip: padding-box;
  },
`;
